import styled from "styled-components";

const SubtitleWrapper = styled.div`
  max-width: ${(props) => (props.maxWidth ? props.maxWidth : "fit-content")};
  font-size: ${(props) => (props.fontSize ? props.fontSize : "18px")};
  font-weight: ${(props) => (props.fontWeight ? props.fontWeight : 400)};
  color: ${(props) => (props.color ? props.color : "#626262")};
  font-family: "Neuton", serif;
  margin-top: ${(props) => (props.marginTop ? props.marginTop : "0")};
  margin-bottom: ${(props) => (props.marginBottom ? props.marginBottom : "0")};
  line-height: ${(props) => (props.lineHeight ? props.lineHeight : "")};
  text-align: ${(props) => (props.textAlign ? props.textAlign : "")};

  @media (max-width: 1023.5px) {
    max-width: ${(props) => (props.maxWidthMd ? props.maxWidthMd : "")};
    text-align: ${(props) => (props.textAlignMd ? props.textAlignMd : "")};
  }
  @media (max-width: 767.5px) {
    font-size: ${(props) => (props.fontSizeSm ? props.fontSizeSm : "")};
    text-align: ${(props) => (props.textAlignSm ? props.textAlignSm : "")};
    margin-top: ${(props) => (props.marginTopSm ? props.marginTopSm : "")};
    margin-bottom: ${(props) =>
      props.marginBottomSm ? props.marginBottomSm : ""};
  }
`;

export default SubtitleWrapper;
